import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { formattedWeight } from "@jti/fe-common";

import styles from "./ProductSpecificationElement.module.scss";

type ProductSpecificationElementType = {
  label: string;
  value: string;
  className?: string;
};

export const ProductSpecificationElement: FC<ProductSpecificationElementType> = ({ label, value, className }) => {
  const { __ } = useTranslations();

  if (!value) {
    return null;
  }

  const formattedValue = label.toLowerCase() === "weight" ? formattedWeight(__, value) : value;

  return (
    <div data-testid="product-specification-item" className={classNames(styles.container, className)}>
      <div className={styles.section}>
        <span className={styles.label}>{__(`productspecification.attribute.${label}`)}</span>
      </div>
      <div className={styles.section}>
        <span className={styles.value}>{formattedValue}</span>
      </div>
    </div>
  );
};
